import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { IBlog } from 'src/app/shared/models/Iblog';

@Component({
  selector: 'app-blog-item',
  templateUrl: './blog-item.component.html',
  styleUrls: ['./blog-item.component.scss']
})
export class BlogItemComponent implements OnInit {
  @Input()
  public blog:IBlog;
  @Input()
   public viewBtn:boolean=true;
  constructor(  private router:Router) { }

  ngOnInit(): void {
  }
  goTo(link_detalle:string){
    this.router.navigate([link_detalle]);
  }
}
